import { Base } from "@studiometa/js-toolkit";
import { withTransition } from "../decorators/index.js";
class Transition extends withTransition(Base) {
  /**
   * Config.
   */
  static config = {
    name: "Transition"
  };
}
export {
  Transition
};
//# sourceMappingURL=Transition.js.map
